export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8686.c467e52d.jpg";